import { Card } from './Card'
import { DateTime } from 'luxon'
import { Sender } from './Sender'
import { Content } from './Content'
import { Attachments } from './Attachments'
import { useTw } from '../../../../../../../utils/Styles'
import { ConversationQuery } from '../../Conversation.generated'
import { ConversationSenderType } from '../../../../../../../api/types'
import { formatDistanceToNowShort } from '../../../../../../../utils/formatDistanceShort'

type ConversationEvent = ConversationQuery['Conversation']['messages'][0]
type StampProps = { received: boolean; createdAt: string }

function Stamp({ received, createdAt }: StampProps) {
  const tw = useTw()
  return (
    <span
      className={tw`block pt-1 pl-1 uppercase text-xs !mt-0.5 text-gray-500 ${
        received ? 'text-right' : 'text-left'
      }`}
    >
      {formatDistanceToNowShort(DateTime.fromISO(createdAt))}
    </span>
  )
}

type EventProps = { event: ConversationEvent }

export function Event({ event }: EventProps) {
  const tw = useTw()
  const received = event.senderType !== ConversationSenderType.Visitor

  return (
    <div
      className={tw`flex p-3 ${event.card && 'w-full'} ${
        received && 'flex-row-reverse'
      }`}
    >
      <Sender event={event} />
      <div className={tw`ml-3 mr-3 min-w-0 space-y-2`}>
        {event.content ? <Content event={event} received={received} /> : null}
        <Card event={event} />
        <Attachments received={received} attachments={event.attachments} />
        <Stamp received={received} createdAt={event.createdAt} />
      </div>
      <div className={tw`flex-shrink-0 h-10 w-10`} />
    </div>
  )
}
